import { type AxiosInstance } from "axios";
import {
  type SendToPartnerRequest,
  type SendToPartnerResponse,
} from "@/features/partner/types";

/**
 * 参謀くん（DataCollaborationPartner.id = SAMBO_KUN_PARTNER_ID）向けに
 * 物件・所有者情報を送信する。バックエンド経由でサーバー間連携される。
 *
 * @param apiClient - 認証済み axios インスタンス
 * @param partnerId - 連携先パートナーID（参謀くんの場合 {@link SAMBO_KUN_PARTNER_ID}）
 * @param body - 解析リクエストID（owner / allMatters のいずれか）
 * @returns 参謀くん API の応答（成功時は `redirectUri` を含む）
 */
export const sendPropertyAndOwnerInfo = async (
  apiClient: AxiosInstance,
  partnerId: number,
  body: SendToPartnerRequest
): Promise<SendToPartnerResponse> => {
  const response = await apiClient.post<SendToPartnerResponse>(
    `/partner/${partnerId}/property-and-owner-info`,
    body
  );
  return response.data;
};
